import axios from "axios";

// Search Api Functions
export async function cityNameSearch(query) {
  if (query.length < 3) return [];

  const BASE_URL = process.env.REACT_APP_BASE_URL;

  try {
    const response = await fetch(
      `${BASE_URL}/affiliates/affiliateregions?cityName=${query}`
    );

    if (!response.ok) throw new Error("Error Fetching Cities");

    const data = await response.json();

    return data.regionDetails;
  } catch (error) {
    throw new Error("Error Fetching Cities");
  }
}

export async function placesDetailsSource(place_id) {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  try {
    const response = await fetch(
      `${BASE_URL}/places/placesDetailsSource?place_id=${place_id}`
    );

    if (!response.ok) {
      throw new Error("Error Fetching City's place id");
    }

    const data = await response.json();

    return data;
  } catch (error) {
    throw new Error("Error Occurred");
  }
}

export async function placesAutoComplete(query) {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  try {
    const response = await fetch(
      `${BASE_URL}/places/placesAutoComplete?input=${query}`
    );

    if (!response.ok) {
      throw new Error("Error Fetching City's place id");
    }

    const data = await response.json();

    return data;
  } catch (error) {
    throw new Error("Error Occurred");
  }
}

// Extranet City API Actions
export const getAllCitiesAction = async (payload) => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const affiliateId = payload.affiliateId;

  if (!affiliateId) return;

  const response = await axios.get(
    `${BASE_URL}/affiliates/trk/cities?affid=${affiliateId}`,
    {
      headers: {
        Authorization: payload.token,
      },
      withCredentials: true,
    }
  );

  return response;
};

export const createNewCityAction = async (payload) => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const newCity = payload;

  await new Promise((r) => setTimeout(r, 5000));

  const newCityObj = { ...newCity };
  if (newCityObj["token"]) {
    delete newCityObj["token"];
  }

  const response = await axios.post(
    `${BASE_URL}/affiliates/trk/city`,
    newCityObj,
    {
      headers: {
        Authorization: payload.token,
      },
      withCredentials: true,
    }
  );

  return response;
};

export const deleteCityAction = async (payload) => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;

  const cityId = payload.cityId;
  const token = payload.token;

  const response = await axios.delete(
    `${BASE_URL}/affiliates/trk/cities?cityId=${cityId}`,
    {
      headers: {
        Authorization: token,
      },
      withCredentials: true,
    }
  );

  return response;
};

// Extranet Zone API Actions
export const createZoneByCityIdAction = async (payload) => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;

  const { token, ...zonePayload } = payload;

  const response = await axios.post(
    `${BASE_URL}/affiliates/trk/zonesPricing`,
    {
      ...zonePayload,
      pricing: {},
      newCarCategory: {},
    },
    {
      headers: {
        Authorization: token,
      },
      withCredentials: true,
    }
  );

  return response;
};

export const getZonesByCityIdAction = async (payload) => {
  const BASE_URL = process.env.REACT_APP_BASE_URL; // cityId: string

  const { token, cityId } = payload;

  const response = await axios.get(
    `${BASE_URL}/affiliates/trk/zonesPricing?cityId=${cityId}`,
    {
      headers: {
        Authorization: token,
      },
      withCredentials: true,
      data: {
        token,
      },
    }
  );

  return response;
};

export const removeZoneByIdAction = async (payload) => {
  const BASE_URL = process.env.REACT_APP_BASE_URL; // (zoneId: string)

  const { zoneId, token } = payload;

  if (!zoneId) return;

  // also do it in tracklimo admin
  const response = await axios.delete(
    `${BASE_URL}/affiliates/trk/zoneRemove?zone_id=${zoneId}`,
    {
      headers: {
        Authorization: token,
      },
      withCredentials: true,
    }
  );

  return response;
};

export const updateZonePricingByIdAction = async (payload) => {
  // zoneId: string,
  // pricing: Record<string, Record<string, string>>,

  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const { zoneId, pricing } = payload;

  const response = await axios.patch(
    `${BASE_URL}/affiliates/zonesPricing?zone_id=${zoneId}`,
    {
      pricing,
    }
  );

  return response;
};
